/**
 * -----------------------------------------------------------------------------
 * Project  : ReelConsensus app - Frontend Page: Sitemap
 * File     : Sitemap.js
 * Author   : Zachary Dry
 * Created  : 2025-09-18
 * Updated  : 2025-09-19
 * Version  : 1.0
 * License: Proprietary (Company Confidential)
 * -----------------------------------------------------------------------------
 * Description:
 *   React page component rendering the Sitemap view and coordinating data fetching.
 *   Exports: Sitemap
 *   
 *
 * Dependencies:
 *   - @mui/material
 *   - react
 *
 * Usage:
 *   Use in Router: <Route path="/sitemap" element={<Sitemap />} />
 * -----------------------------------------------------------------------------
 */
import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';

const Sitemap = () => {
  const routes = [
    '/',
    '/vote',
    '/results/:pollId',
    '/history',
    '/previously-watched',
    '/post-view-ratings',
    '/clubs',
    '/clubs/:id',
    '/clubs/:clubId/streamer',
    '/physical-media',
    '/clz-migration',
    '/plex',
    '/metrics',
    '/admin',
    '/api-docs',
    '/pricing',
    '/privacy-policy',
    '/terms-and-conditions',
    '/sitemap'
  ];
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Sitemap</Typography>
      <List>
        {routes.map((r) => (
          <ListItem key={r} component={Link} to={r.replace(':pollId','1')}>
            <ListItemText primary={r} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Sitemap;


